import {
  AvailableReadProviders,
  IPartialRpcUrlsConfig,
  ProviderManager,
  DEFAULT_RPC,
  EEthereumNetworkId,
  IProvidersMap,
} from '@ankr.com/provider';

import {
  ARBITRUM_RPC_URL,
  ARBITRUM_SEPOLIA_TESTNET_RPC_URL,
  BSC_RPC_URL,
  BSC_TESTNET_RPC_URL,
  ETH_HOLESKY_RPC_URL,
  ETH_RPC_URL,
  FANTOM_RPC_URL,
  FANTOM_TESTNET_RPC_URL,
  OPTIMISIM_RPC_URL,
  OPTIMISM_TESTNET_RPC_URL,
  POLYGON_RPC_URL,
  SCROLL_RPC_URL,
  SCROLL_SEPOLIA_TESTNET_RPC_URL,
} from './constants';
import { getWeb3EthRpcUrl } from './utils/getWeb3Instance';

const RPC_URLS: IPartialRpcUrlsConfig = {
  [AvailableReadProviders.arbitrumSepoliaTestnet]:
    ARBITRUM_SEPOLIA_TESTNET_RPC_URL,
  [AvailableReadProviders.arbitrum]: ARBITRUM_RPC_URL,
  [AvailableReadProviders.binanceChainTest]: BSC_TESTNET_RPC_URL,
  [AvailableReadProviders.binanceChain]: BSC_RPC_URL,
  [AvailableReadProviders.ethHolesky]: ETH_HOLESKY_RPC_URL,
  [AvailableReadProviders.ethMainnet]: ETH_RPC_URL,
  [AvailableReadProviders.ftmOpera]: FANTOM_RPC_URL,
  [AvailableReadProviders.ftmTestnet]: FANTOM_TESTNET_RPC_URL,
  [AvailableReadProviders.optimismTestnet]: OPTIMISM_TESTNET_RPC_URL,
  [AvailableReadProviders.optimism]: OPTIMISIM_RPC_URL,
  [AvailableReadProviders.polygon]: POLYGON_RPC_URL,
  [AvailableReadProviders.scrollTestnet]: SCROLL_SEPOLIA_TESTNET_RPC_URL,
  [AvailableReadProviders.scroll]: SCROLL_RPC_URL,
};

export class ProviderManagerSingleton {
  private static instance?: ProviderManager<IProvidersMap>;

  public static getInstance() {
    if (ProviderManagerSingleton.instance) {
      return ProviderManagerSingleton.instance;
    }

    DEFAULT_RPC[EEthereumNetworkId.mainnet] = getWeb3EthRpcUrl();

    ProviderManagerSingleton.instance = new ProviderManager(
      undefined,
      RPC_URLS,
    );

    return ProviderManagerSingleton.instance;
  }

  public static removeInstance() {
    ProviderManagerSingleton.instance = undefined;
  }
}
